// Libs
import PropTypes from 'prop-types';
// Components
import IconTooltip from '@/common-utils/components/renders/iconTooltip/IconTooltip';
import { Separator } from '../../ui/separator';
// Common
import ICONS from '@/common-utils/enums/icons';

/**
 * @param root0
 * @param root0.items
 * @param root0.valueKey
 * @returns {JSX}
 */
function LegendMoreItemsTooltip({ items, valueKey }) {

    // Constants
    const visibleItems = (items || []).filter((item) => item?.type !== 'none');

    if (!visibleItems.length) {
        return null;
    }

    return (
        <IconTooltip
            icon={ICONS.MESSAGE_SQUARE_MORE}
            content={
                <div className='grid grid-cols-2 gap-x-4 gap-y-2'>
                    {visibleItems.map((item) => (
                        <div
                            key={item.value}
                            className='flex items-center gap-2 text-xs text-foreground whitespace-nowrap'
                        >
                            <div
                                className='h-2 w-2 shrink-0 rounded-[2px]'
                                style={{ backgroundColor: item.color }}
                            />
                            <span>
                                {item.value}
                            </span>
                            <Separator orientation='vertical' className='h-4' />
                            <span className='font-medium'>
                                {item?.payload?.[valueKey]}
                            </span>
                        </div>
                    ))}
                </div>
            }
        />
    );
}

LegendMoreItemsTooltip.propTypes = {
    items: PropTypes.array.isRequired,
    valueKey: PropTypes.string
};

export default LegendMoreItemsTooltip;

